import * as tslib_1 from "tslib";
import React from 'react';
import contains from 'dom-helpers/query/contains';
import addEventListener from 'dom-helpers/events/on';
import removeEventListener from 'dom-helpers/events/off';
import { DropdownNativeContext } from '../Dropdown/context';
var getOwnerDocument = function (node) { return (node && node.getOwnerDocument) || document; };
var isLeftClickEvent = function (event) {
    return event.button === 0;
};
var isModifiedEvent = function (event) {
    return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
};
var MenuCloserContent = /** @class */ (function (_super) {
    tslib_1.__extends(MenuCloserContent, _super);
    function MenuCloserContent() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.shouldClose = false;
        _this.rootRef = null;
        _this.setRootRef = function (node) {
            _this.rootRef = node;
            _this.props.innerRef && _this.props.innerRef(node);
        };
        _this.handleMouseCapture = function (e) {
            _this.shouldClose =
                isLeftClickEvent(e) &&
                    !isModifiedEvent(e) &&
                    !contains(_this.rootRef, e.target);
        };
        _this.handleMouse = function (e) {
            if (_this.shouldClose && _this.props.onClose) {
                _this.props.onClose(e);
            }
        };
        _this.handleKeyUp = function (e) {
            if (e.keyCode === 27 && _this.props.onClose) {
                _this.props.onClose(e);
            }
        };
        return _this;
    }
    MenuCloserContent.prototype.render = function () {
        return React.createElement("span", { ref: this.setRootRef }, this.props.children);
    };
    MenuCloserContent.prototype.componentDidMount = function () {
        if (this.props.isNative) {
            return;
        }
        if (this.props.isNative || !this.props.disabled) {
            this.addEventListeners();
        }
    };
    MenuCloserContent.prototype.componentDidUpdate = function (prevProps) {
        if (this.props.isNative) {
            return;
        }
        if (!this.props.disabled && prevProps.disabled) {
            this.addEventListeners();
        }
        else if (this.props.disabled && !prevProps.disabled) {
            this.removeEventListeners();
        }
    };
    MenuCloserContent.prototype.componentWillUnmount = function () {
        if (this.props.isNative) {
            return;
        }
        if (!this.props.disabled) {
            this.removeEventListeners();
        }
    };
    MenuCloserContent.prototype.addEventListeners = function () {
        var doc = getOwnerDocument(this.rootRef);
        // Use capture for this listener so it fires before React's listener, to
        // avoid false positives in the contains() check below if the target DOM
        // element is removed in the React mouse callback.
        addEventListener(doc, 'click', this.handleMouseCapture, true);
        addEventListener(doc, 'click', this.handleMouse);
        addEventListener(doc, 'keyup', this.handleKeyUp);
    };
    MenuCloserContent.prototype.removeEventListeners = function () {
        var doc = getOwnerDocument(this.rootRef);
        removeEventListener(doc, 'click', this.handleMouseCapture, true);
        removeEventListener(doc, 'click', this.handleMouse);
        removeEventListener(doc, 'keyup', this.handleKeyUp);
    };
    return MenuCloserContent;
}(React.Component));
var MenuCloser = function (props) { return (React.createElement(DropdownNativeContext.Consumer, null, function (isNative) { return React.createElement(MenuCloserContent, tslib_1.__assign({ isNative: isNative }, props)); })); };
MenuCloser.displayName = 'MenuCloser';
export default MenuCloser;
//# sourceMappingURL=MenuCloser.js.map